import { healthdexAllowedDomain } from "@/constants/invalid-domain/healthdex-allowed-domain";
import { tradexAllowedDomain } from "@/constants/invalid-domain/tradex-allowed-domain";
import { buildexAllowedDomain } from "@/constants/invalid-domain/buildex-allowed-domain";
import invalidDomain from "@/constants/invalid-domain/index";
import { DEX_TYPE } from '@/config/constants';

export function validateEmail(email) {
	const pattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/g;
	if (pattern.test(email)) {
		return true
	}
	return false
}

export function validateDomain(email, dexEnv) {
	const domain = email.split("@")[1];
	let invalidDomains = invalidDomain;

	if (dexEnv === DEX_TYPE.SGHEALTHDEX) {
		invalidDomains = invalidDomains.filter((domain) => !healthdexAllowedDomain.includes(domain));
	}
	if (dexEnv === DEX_TYPE.SGTRADEX) {
		invalidDomains = invalidDomains.filter((domain) => !tradexAllowedDomain.includes(domain));
	}
	if (dexEnv === DEX_TYPE.SGBUILDEX) {
		invalidDomains = invalidDomains.filter((domain) => !buildexAllowedDomain.includes(domain));
	}
	return !invalidDomains.includes(domain);
}

export function validatePitstopURL(shortName) {
	const pattern = /^[a-zA-Z0-9-_]+$/g;
	return pattern.test(shortName);
}
